module.exports = __webpack_public_path__ + "static/img/huaweiMateBook13.3b348fa5.png";